import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgBadkamer = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#0061CD"
      d="M28 26H12a2 2 0 0 1-2-2h20a2 2 0 0 1-2 2"
    />
    <path
      fill="#85BDED"
      fillRule="evenodd"
      d="M10 24a10 10 0 0 1 20 0"
      clipRule="evenodd"
    />
    <path
      fill="#85BDED"
      d="M22 6h-4v12h4zM13.98 30.02a1 1 0 1 0 0-2 1 1 0 0 0 0 2M17.99 30.02a1 1 0 1 0 0-2 1 1 0 0 0 0 2M21.99 30.02a1 1 0 1 0 0-2 1 1 0 0 0 0 2M26 30.02a1 1 0 1 0 0-2 1 1 0 0 0 0 2M11.98 34a1 1 0 1 0 0-2 1 1 0 0 0 0 2M15.99 34a1 1 0 1 0 0-2 1 1 0 0 0 0 2M19.99 34a1 1 0 1 0 0-2 1 1 0 0 0 0 2M24 34a1 1 0 1 0 0-2 1 1 0 0 0 0 2M28 34a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M21.5 16V8h1v8z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgBadkamer);

export default ForwardRef;
